import PropTypes from 'prop-types';
export const interactionPropTypes = {
  disabled: PropTypes.bool,
  focused: PropTypes.bool,
  hovered: PropTypes.bool,
  pressed: PropTypes.bool
};